/**
 * THE PRODUCTION ASSET MANIFEST — GENERATED, DO NOT HAND-EDIT.
 *
 * Regenerate with `node scripts/freeze-asset-manifest.mjs`; `--check` diffs it
 * in CI so a re-export that was not re-frozen fails the build.
 *
 * ── WHY THIS EXISTS ──────────────────────────────────────────────────────────
 *
 * The optimised player GLB embeds no image. Its one material points at a SIBLING
 * file by relative URI (`player-master-atlas.png`), so the shipped athlete is TWO
 * files and the loader will happily produce a plausible result from one of them:
 * three resolves the URI against the GLB's directory, a 404 leaves `map`
 * undefined, and the character draws as a blank white mannequin — correctly lit,
 * correctly posed, correct height, every metric healthy. That failure has already
 * shipped in this project once.
 *
 * So the package is declared here by CONTENT, not by convention: the SHA-256 of
 * every file, the atlas's real IHDR dimensions, the URI the GLB actually asks
 * for (parsed out of the glTF JSON chunk), and the per-LOD mesh/primitive/
 * material/triangle/bone counts that make "one merged SkinnedMesh with one
 * material" a number rather than an intention.
 *
 * `productionAssetIntegrity.ts` turns this table into a startup assertion.
 *
 * ── WHAT IS DELIBERATELY NOT HERE ────────────────────────────────────────────
 *
 * The authored `Footy_Arena_Player_LOD*.glb` exports. They are 12-20 meshes and
 * 12-19 materials with their own embedded textures, and they have been moved OUT
 * of `packages/client/public/` entirely — out of everything Vite serves — into
 * `assets/archive/player-master-19material-baseline`.
 * They are recorded below by hash so the move is verifiable and reversible;
 * `ARCHIVED_BASELINE` exists to be asserted UNREACHABLE, not to be loaded.
 */

/** Hash of the atlas, the LOD table and the skeleton contract version. */
export const PRODUCTION_ASSET_MANIFEST_VERSION = "player-master-assets-1.01e7c50057e2a7d4";

/** The skeleton contract this package was frozen against. */
export const PRODUCTION_ASSET_CONTRACT_VERSION = "player-master-1.a4b23dda95663eeb";

/** The shared texture every LOD samples. One image for the whole athlete. */
export interface ProductionAtlasAsset {
  /** Repo-relative, for tooling and tests. */
  readonly path: string;
  /** Runtime URL, i.e. the path with the public root stripped. */
  readonly url: string;
  readonly sha256: string;
  readonly bytes: number;
  readonly width: number;
  readonly height: number;
}

export interface ProductionMeshAsset {
  readonly lod: number;
  readonly path: string;
  readonly url: string;
  readonly sha256: string;
  readonly bytes: number;
  /**
   * The relative URI THIS FILE asks for, read out of its glTF JSON chunk. It is
   * resolved against the GLB's own directory, which is why the atlas has to be
   * deployed as a sibling and not merely deployed somewhere.
   */
  readonly atlasUri: string;
  readonly meshes: number;
  readonly primitives: number;
  readonly materials: number;
  readonly triangles: number;
  readonly bones: number;
  readonly maxInfluences: number;
  readonly alphaMode: string;
  readonly alphaCutoff: number | null;
  readonly materialName: string;
  /** Bind-pose height in metres, off the POSITION accessor's own bounds. */
  readonly heightM: number;
  /** Lowest bind-pose vertex. ~0 or the boots float or sink. */
  readonly soleM: number;
}

export const PRODUCTION_ATLAS: ProductionAtlasAsset = {
  "path": "packages/client/public/characters/player-master/player-master-atlas.png",
  "url": "/characters/player-master/player-master-atlas.png",
  "sha256": "551efa3025777e9713bf3de11f8df3441e219243f532b34cf0a2989fcf647d59",
  "bytes": 2268764,
  "width": 2048,
  "height": 2048
};

export const PRODUCTION_MESHES: readonly ProductionMeshAsset[] = [
  {
    "lod": 0,
    "path": "packages/client/public/characters/player-master/player-master-lod0.glb",
    "url": "/characters/player-master/player-master-lod0.glb",
    "sha256": "d87bce3d339ba526b82dd09ef0fcb66a078e8fb1bdd5f81ca81a1950ff393bf5",
    "bytes": 1769904,
    "atlasUri": "player-master-atlas.png",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "triangles": 29378,
    "bones": 74,
    "maxInfluences": 4,
    "alphaMode": "MASK",
    "alphaCutoff": null,
    "materialName": "FootyPlayer",
    "heightM": 1.8039,
    "soleM": 0
  },
  {
    "lod": 1,
    "path": "packages/client/public/characters/player-master/player-master-lod1.glb",
    "url": "/characters/player-master/player-master-lod1.glb",
    "sha256": "c91cad8bfbed5e36be42bae317f0e8d26f04e35fe128087108b7c5ac9b7c58a9",
    "bytes": 1626432,
    "atlasUri": "player-master-atlas.png",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "triangles": 24999,
    "bones": 74,
    "maxInfluences": 4,
    "alphaMode": "MASK",
    "alphaCutoff": null,
    "materialName": "FootyPlayer",
    "heightM": 1.8039,
    "soleM": 0
  },
  {
    "lod": 2,
    "path": "packages/client/public/characters/player-master/player-master-lod2.glb",
    "url": "/characters/player-master/player-master-lod2.glb",
    "sha256": "861e8a2ce1d1fe8a779bbf3e7083ad7a155d16a0335823ef6c9f5cb001908781",
    "bytes": 1033016,
    "atlasUri": "player-master-atlas.png",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "triangles": 9999,
    "bones": 74,
    "maxInfluences": 4,
    "alphaMode": "MASK",
    "alphaCutoff": null,
    "materialName": "FootyPlayer",
    "heightM": 1.807287,
    "soleM": 0.002203
  },
  {
    "lod": 3,
    "path": "packages/client/public/characters/player-master/player-master-lod3.glb",
    "url": "/characters/player-master/player-master-lod3.glb",
    "sha256": "b8c15f8d3c580564399c9fb05f0e18af74ff85246476c9907ba90af170483053",
    "bytes": 239032,
    "atlasUri": "player-master-atlas.png",
    "meshes": 1,
    "primitives": 1,
    "materials": 1,
    "triangles": 3000,
    "bones": 74,
    "maxInfluences": 4,
    "alphaMode": "MASK",
    "alphaCutoff": null,
    "materialName": "FootyPlayer",
    "heightM": 1.808393,
    "soleM": 0.002011
  }
];

/** LOD used by the gameplay camera (~17-20 m). What ships as final-athlete. */
export const PRODUCTION_PRIMARY_LOD = 1;

export function productionMesh(lod: number = PRODUCTION_PRIMARY_LOD): ProductionMeshAsset {
  const m = PRODUCTION_MESHES.find((x) => x.lod === lod);
  if (!m) {
    throw new Error(
      `no production mesh for LOD ${lod}; the manifest ships ` +
        `${PRODUCTION_MESHES.map((x) => x.lod).join(', ')}`,
    );
  }
  return m;
}

/**
 * THE COMPLETE DEPLOYMENT PACKAGE. Every file that must reach the build output
 * for the athlete to render as authored. Dropping any one of them is a silent
 * failure, which is the only reason this list is a list.
 */
export const PRODUCTION_ASSET_FILES: readonly string[] = [
  "packages/client/public/characters/player-master/player-master-lod0.glb",
  "packages/client/public/characters/player-master/player-master-lod1.glb",
  "packages/client/public/characters/player-master/player-master-lod2.glb",
  "packages/client/public/characters/player-master/player-master-lod3.glb",
  "packages/client/public/characters/player-master/player-master-atlas.png"
];

export interface ArchivedAsset {
  readonly path: string;
  readonly sha256: string;
  readonly bytes: number;
  /** The live file that replaced it, or null for reports and specs. */
  readonly supersededBy: string | null;
  readonly reason: string;
}

/** Where the superseded baseline lives. Outside everything Vite serves. */
export const ARCHIVED_BASELINE_DIR = "assets/archive/player-master-19material-baseline";

/**
 * The 19-material authored exports and their reports, preserved by hash after
 * being moved out of the served tree. NOTHING MAY LOAD THESE. They are listed so
 * that "no production loader falls back to the old exports" is a test over a
 * concrete file list instead of a promise.
 */
export const ARCHIVED_BASELINE: readonly ArchivedAsset[] = [
  {
    "path": "assets/archive/player-master-19material-baseline/Footy_Arena_Player_LOD0.glb",
    "sha256": "0edef5099a9c21be0cce3ab47f63ba3e48f0e622aafd2ebb24facd13ddde84ce",
    "bytes": 4749836,
    "supersededBy": "player-master-lod0.glb",
    "reason": "20 meshes / 19 materials, embedded per-LOD textures — 20 draw calls per player"
  },
  {
    "path": "assets/archive/player-master-19material-baseline/Footy_Arena_Player_LOD1.glb",
    "sha256": "f1b08acc7bde2a823f0802afdb282e223051268c8c7c9c76cf2fc636f6e7dfa0",
    "bytes": 3943268,
    "supersededBy": "player-master-lod1.glb",
    "reason": "12 meshes / 18 materials, embedded per-LOD textures"
  },
  {
    "path": "assets/archive/player-master-19material-baseline/Footy_Arena_Player_LOD2.glb",
    "sha256": "ba20498f1bddcda5970254141f626fab3a6a58acf885b694fe6e2b46a9e99ef7",
    "bytes": 3443212,
    "supersededBy": "player-master-lod2.glb",
    "reason": "9 meshes / 15 materials, embedded per-LOD textures"
  },
  {
    "path": "assets/archive/player-master-19material-baseline/Footy_Arena_Player_LOD3.glb",
    "sha256": "88ad739231f66489502e9059c76e1dcbbc594907160ccfb0ca936cb455485007",
    "bytes": 3193608,
    "supersededBy": "player-master-lod3.glb",
    "reason": "6 meshes / 12 materials, embedded per-LOD textures"
  },
  {
    "path": "assets/archive/player-master-19material-baseline/Footy_Arena_Player_Materials.json",
    "sha256": "5abfb8d6ede3c112b468832471c1428992f445db78e4642bf184eb2b527470c2",
    "bytes": 2523,
    "supersededBy": null,
    "reason": "recolour contract keyed on the 19 authored material NAMES; the merged export has one material and recolouring moves into the atlas"
  },
  {
    "path": "assets/archive/player-master-19material-baseline/export_report.json",
    "sha256": "a8e1a8391c886f1f461988c3a2c496ae96dba346738ee8117265866c66d8e906",
    "bytes": 2320,
    "supersededBy": "optimized_report.json",
    "reason": "validation report for the 19-material exports. PRESERVED AS FOUND — it was truncated to hero-only before this session and is archived verbatim, not reconstructed"
  },
  {
    "path": "assets/archive/player-master-19material-baseline/README_PLAYER_INTEGRATION.md",
    "sha256": "117498413b06e84e4f3b27c83f1e599b811f0d7230fffd9903c5ea6fba2ef31b",
    "bytes": 3119,
    "supersededBy": null,
    "reason": "integration notes for the 19-material exports; documents per-material recolouring and \"22 unique draws/player\" that the merged export removes"
  }
];

/** Basenames of the archived files, for reachability assertions over source. */
export const ARCHIVED_BASELINE_BASENAMES: readonly string[] = [
  "Footy_Arena_Player_LOD0.glb",
  "Footy_Arena_Player_LOD1.glb",
  "Footy_Arena_Player_LOD2.glb",
  "Footy_Arena_Player_LOD3.glb",
  "Footy_Arena_Player_Materials.json",
  "export_report.json",
  "README_PLAYER_INTEGRATION.md"
];
